/* FESTO landing · nube de puntos del hero (canvas). Respeta reduced-motion. */
(function () {
  function initCanvas(c) {
    if (!c || c.dataset.started) return;
    c.dataset.started = '1';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var ctx = c.getContext('2d'), W, H, pts = [], t = 0, raf;
    function size() { var r = c.parentElement.getBoundingClientRect(); W = c.width = r.width; H = c.height = Math.max(r.height, 1); build(); }
    function build() { pts = []; var n = Math.min(140, Math.floor(W / 9)); for (var i = 0; i < n; i++) pts.push({ x: Math.random() * W, y: Math.random() * H, r: Math.random() * 1.8 + 0.6, px: Math.random() * 6.28 }); }
    function pos(p) { return [p.x + Math.cos(t * 1.5 + p.px) * 8, p.y + Math.sin(t * 2 + p.px) * 10]; }
    function frame() {
      ctx.clearRect(0, 0, W, H); t += 0.006;
      for (var i = 0; i < pts.length; i++) {
        var a = pos(pts[i]);
        ctx.beginPath(); ctx.arc(a[0], a[1], pts[i].r, 0, 6.283);
        ctx.fillStyle = 'rgba(120,190,240,' + (0.25 + 0.4 * Math.abs(Math.sin(t + pts[i].px))) + ')'; ctx.fill();
        for (var j = i + 1; j < pts.length; j++) {
          var b = pos(pts[j]); var dx = a[0] - b[0], dy = a[1] - b[1], dd = dx * dx + dy * dy;
          if (dd < 5200) { ctx.strokeStyle = 'rgba(100,170,230,' + (0.12 * (1 - dd / 5200)) + ')'; ctx.lineWidth = 0.6; ctx.beginPath(); ctx.moveTo(a[0], a[1]); ctx.lineTo(b[0], b[1]); ctx.stroke(); }
        }
      }
      if (!reduce) raf = requestAnimationFrame(frame);
    }
    size(); window.addEventListener('resize', size); frame();
  }
  function boot() { var c = document.querySelector('.ft-canvas'); if (c) initCanvas(c); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var c = e.target.querySelector ? e.target.querySelector('.ft-canvas') : null; if (c) { c.dataset.started = ''; initCanvas(c); } });
})();
